import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from "../config";

export const fetchAdmissionPeriod = createAsyncThunk(
  "admissionPeriod/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/AdmissionWindow`, {
        headers: {
          Accept: "application/json",
        },
      });

      const admissionWindows = response.data;
      //console.log("admissionWindows", admissionWindows);
      // Filter active admission windows
      const currentDate = new Date();
      console.log("admissionWindows", admissionWindows);
 
      const activeWindows = admissionWindows.filter(
        (window) =>
          window.state &&
          new Date(window.admissionWindowStartDate) <= currentDate &&
          new Date(window.admissionWindowEndDate) >= currentDate
      );
      console.log("activeWindows", activeWindows);
      // Separate windows for new and existing parents
      const newParentWindow = activeWindows
        .filter((window) => window.openFor === 0 || window.openFor === 3) // Filter windows based on openFor
        .reduce((latestWindow, currentWindow) => {
          // Compare admissionWindowEndDate of latestWindow and currentWindow
          if (
            !latestWindow ||
            new Date(currentWindow.admissionWindowEndDate) >
              new Date(latestWindow.admissionWindowEndDate)
          ) {
            return currentWindow; // Return currentWindow if it's more recent
          }
          return latestWindow; // Otherwise, return latestWindow
        }, null); // Start with null as initial value

      const existingParentWindow = activeWindows
        .filter((window) => window.openFor === 1 || window.openFor === 3) // Filter windows based on openFor
        .reduce((latestWindow, currentWindow) => {
          // Compare admissionWindowEndDate of latestWindow and currentWindow
          if (
            !latestWindow ||
            new Date(currentWindow.admissionWindowEndDate) >
              new Date(latestWindow.admissionWindowEndDate)
          ) {
            return currentWindow; // Return currentWindow if it's more recent
          }
          return latestWindow; // Otherwise, return latestWindow
        }, null); // Start with null as initial value
      const staffWindow = activeWindows
        .filter((window) => window.openFor === 2 || window.openFor === 3) // Filter windows based on openFor
        .reduce((latestWindow, currentWindow) => {
          // Compare admissionWindowEndDate of latestWindow and currentWindow
          if (
            !latestWindow ||
            new Date(currentWindow.admissionWindowEndDate) >
              new Date(latestWindow.admissionWindowEndDate)
          ) {
            return currentWindow; // Return currentWindow if it's more recent
          }
          return latestWindow; // Otherwise, return latestWindow
        }, null); // Start with null as initial value

      return {
        newParentWindow: newParentWindow
          ? {
              startDate: newParentWindow.admissionWindowStartDate,
              endDate: newParentWindow.admissionWindowEndDate,
              name: newParentWindow.admissionWindowName,
              isOpen: true,
            }
          : null,
        existingParentWindow: existingParentWindow
          ? {
              startDate: existingParentWindow.admissionWindowStartDate,
              endDate: existingParentWindow.admissionWindowEndDate,
              name: existingParentWindow.admissionWindowName,
              isOpen: true,
            }
          : null,
        staffWindow: staffWindow
          ? {
              startDate: staffWindow.admissionWindowStartDate,
              endDate: staffWindow.admissionWindowEndDate,
              name: staffWindow.admissionWindowName,
              isOpen: true,
            }
          : null,

        isOpen: activeWindows.length > 0,
      };
    } catch (error) {
      console.error("Detailed Error:", {
        message: error.message,
        response: error.response,
        request: error.request,
        config: error.config,
      });

      return rejectWithValue(
        error.response?.data ||
          error.message ||
          "Failed to fetch admission windows"
      );
    }
  }
);

const admissionPeriodSlice = createSlice({
  name: "admissionPeriod",
  initialState: {
    newParentWindow: null,
    existingParentWindow: null,
    staffWindow: null,
    isOpen: false,
    loading: false,
    error: null,
  },
  reducers: {
    resetAdmissionPeriod: (state) => {
      state.newParentWindow = null;
      state.existingParentWindow = null;
      state.staffWindow = null;
      state.isOpen = false;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdmissionPeriod.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdmissionPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.newParentWindow = action.payload.newParentWindow;
        state.existingParentWindow = action.payload.existingParentWindow;
        state.staffWindow = action.payload.staffWindow;
        state.isOpen = action.payload.isOpen;
      })
      .addCase(fetchAdmissionPeriod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch admission windows";
      });
  },
});

export const { resetAdmissionPeriod } = admissionPeriodSlice.actions;
export default admissionPeriodSlice.reducer;
